import type { CombatRatings } from "@/game/model/character-stats";

/** Apply up to one second of regen; returns carry for fractional rates. */
export function applyHpRegenTick(
  current: number,
  max: number,
  regenPerSec: number,
  carry: number,
): { current: number; carry: number; healed: number } {
  if (current >= max || regenPerSec <= 0) {
    return { current, carry: 0, healed: 0 };
  }
  const nextCarry = carry + regenPerSec;
  const heal = Math.floor(nextCarry);
  if (heal <= 0) {
    return { current, carry: nextCarry, healed: 0 };
  }
  const before = current;
  const after = Math.min(max, current + heal);
  return {
    current: after,
    carry: nextCarry - heal,
    healed: after - before,
  };
}

export function combatRatingsHpRegenPerSec(ratings: CombatRatings): number {
  return Math.max(0, ratings.hpRegenPerSec);
}
